/** @format */

import React from 'react';
import usePageRendered from '../../../../../hooks/usePageRendered';

type Props = {
    children: React.ReactNode;
    id?: string;
    width?: string;
};

const OnboardingRightContainer: React.FC<Props> = ({ children, id, width = '' }) => {
    const pageTransitionCss = usePageRendered();
    return (
        <div className={`flex justify-center ${pageTransitionCss}`} id={id}>
            <div className={`w-full md:w-4/5 lg:w-9/12 xl:w-9/12 ${width}`}>{children}</div>
        </div>
    );
};

export default OnboardingRightContainer;
